import { Icon, Menu, MenuItem, MenuPopup, MenuTrigger } from "@salestrak/ui";
import { FilterToggle, type FilterToggleProps } from "#app/components/filters/filter-toggle";
import {
  ISSUE_TABLE_GROUP_BY_OPTIONS,
  issueTableGroupByLabel,
  type IssueTableGroupBy,
} from "./issue-grouping";

/**
 * THE group-by chip for a widget issue table: a `FilterToggle` reading "Group"
 * at rest and the active dimension's label while grouped, opening the shared
 * dimension menu ({@link ISSUE_TABLE_GROUP_BY_OPTIONS}). Grouping is a
 * per-viewer view choice, so the chip's state is the caller's — transient
 * view-state or plain component state, never persisted here.
 */
export function IssueGroupByChip({
  groupBy,
  onGroupByChange,
  size = "xs",
  offVariant,
}: {
  groupBy: IssueTableGroupBy;
  onGroupByChange: (value: IssueTableGroupBy) => void;
  size?: FilterToggleProps["size"];
  offVariant?: FilterToggleProps["offVariant"];
}) {
  const active = groupBy !== "none";
  return (
    <Menu>
      <MenuTrigger
        render={
          <FilterToggle
            size={size}
            offVariant={offVariant}
            icon="layers"
            label={active ? issueTableGroupByLabel(groupBy) : "Group"}
            selected={active}
            onClear={active ? () => onGroupByChange("none") : undefined}
            tooltip={`Grouping by: ${issueTableGroupByLabel(groupBy)}`}
            clearTooltip="Clear grouping"
          />
        }
      />
      <MenuPopup align="start" minWidth={180}>
        {ISSUE_TABLE_GROUP_BY_OPTIONS.map((option) => (
          <MenuItem key={option.value} onClick={() => onGroupByChange(option.value)}>
            {option.value === groupBy ? <Icon name="check" size="md" /> : null}
            {option.label}
          </MenuItem>
        ))}
      </MenuPopup>
    </Menu>
  );
}
